<ng-container [ngSwitch]="type">
  <ng-container *ngSwitchCase="'list-item'">
    <div class="list-item">
      <div class="details">
        <div class="icon-name">
          <rt-icon name="attach-file" margin-right-small-xx text-light></rt-icon>
          <a *ngIf="isDocumentOrImage()" class="link" (click)="open()">{{ attachment.filename }}</a>
          <a *ngIf="!isDocumentOrImage()" class="link" [href]="attachment.fileUrl">{{
            attachment.filename
          }}</a>
          <span text-light *ngIf="attachment.fileSize" class="size"
            >({{ attachment.fileSize | rtFileSize }})</span
          >
        </div>
        <rt-button
          *ngIf="hasDeleteAction"
          variant="plain only-icon small-x danger-on-hover"
          (click)="delete()"
        >
          <rt-icon name="delete"> </rt-icon>
        </rt-button>
      </div>
      <rt-divider variant="line dark" margin-top-small> </rt-divider>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'card'">
    <div
      class="rt-card"
      [class.additional-opts-visible]="additionalOptsDropdownOpen"
      [class.private]="isPrivate"
    >
      <ng-container *ngTemplateOutlet="preview"></ng-container>
      <ng-container *ngTemplateOutlet="footer"></ng-container>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'compact-card'">
    <div
      class="rt-card rt-card-background-light attachment-small"
      [class.additional-opts-visible]="additionalOptsDropdownOpen"
      [class.private]="isPrivate"
    >
      <ng-container *ngTemplateOutlet="preview"></ng-container>
      <ng-container *ngTemplateOutlet="footer"></ng-container>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'tile'">
    <div
      class="rt-card rt-card-background-light attachment-small-x"
      [class.additional-opts-visible]="additionalOptsDropdownOpen"
      [class.private]="isPrivate"
    >
      <ng-container *ngTemplateOutlet="footer"></ng-container>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'preview'">
    <div
      class="rt-card rt-card-background-light attachment-small"
      [class.additional-opts-visible]="additionalOptsDropdownOpen"
      [class.private]="isPrivate"
    >
      <ng-container *ngTemplateOutlet="preview"></ng-container>
    </div>
  </ng-container>
</ng-container>

<ng-template #preview>
  <div class="preview">
    <img *ngIf="hasThumbnail()" [src]="thumbnailUrl()" (error)="thumbnailLoadError()" />
    <div *ngIf="!hasThumbnail()" class="extension">
      <div class="extension__oval">
        <div text-uppercase text-medium class="extension__name">
          {{ attachment.extension }}
        </div>
      </div>
    </div>
    <div class="overlay context-alt">
      <div class="overlay__inner">
        <div *ngIf="actions.length" class="actions">
          <ng-container *ngIf="actions.length === 1; else multiActions">
            <rt-button
              [class.small]="type === 'compact-card'"
              [ngClass]="actions[0].variant || {}"
              [rtTooltip]="actions[0].label"
              (click)="actions[0].handler()"
              variant="no-padding only-icon"
            >
              <rt-icon [name]="actions[0].icon"></rt-icon>
            </rt-button>
          </ng-container>
          <ng-template #multiActions>
            <rt-button
              #additionalOptsTrigger="rtOverlayOrigin"
              rt-overlay-origin
              variant="no-padding only-icon primary-on-hover small-x"
              (click)="toggleAdditionalOptsDropdown(true, $event)"
            >
              <rt-icon [name]="'more-horiz'"></rt-icon>
            </rt-button>

            <ng-template
              #additionalOpts="rtConnectedOverlay"
              rt-connected-overlay
              [hasBackdrop]="true"
              [offsetX]="-5"
              [origin]="additionalOptsTrigger"
              [open]="additionalOptsDropdownOpen"
              (backdropClick)="toggleAdditionalOptsDropdown(false)"
            >
              <rt-dropdown (click)="$event.preventDefault()">
                <rt-experimental-dropdown-item
                  *ngFor="let action of actions; trackBy: trackByLabel"
                  [slotPrimary]="action.icon"
                  [label]="action.label"
                  [divider]="true"
                  (click)="action.handler()"
                >
                </rt-experimental-dropdown-item>
              </rt-dropdown>
            </ng-template>
          </ng-template>
        </div>

        <div *ngIf="isDocumentOrImage()" (click)="open()" class="open-preview-layer">
          <rt-icon name="visibility" size="medium"> </rt-icon>
        </div>

        <rt-button
          *ngIf="!isDocumentOrImage() && hasDownloadAction"
          [class.small]="type === 'compact-card'"
          [href]="href"
          [hasDownloadAttribute]="true"
          variant="primary"
        >
          <rt-icon name="file-download" size="medium"> </rt-icon>
          {{ translations.previewDialog.downloadFile | translate }}
        </rt-button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #footer>
  <div class="footer">
    <span *ngIf="!hasDownloadAction" text-bold>{{ attachment.filename }}</span>
    <div *ngIf="hasDownloadAction" class="details">
      <rt-icon name="attach-file" *ngIf="type === 'tile'"> </rt-icon>
      <ng-container *ngIf="isPrivate">
        <rt-icon
          [rtTooltip]="'rtu.attachment.private_file_tooltip' | translate"
          [rtTooltipMaxWidth]="200"
          name="lock"
        >
        </rt-icon>
      </ng-container>
      <rt-truncate>
        <ng-container *ngIf="attachment.filename">
          <div *ngIf="!highlightedFilename && isDocumentOrImage()" class="name" (click)="open()">
            {{ attachment.filename }}
          </div>
          <div
            *ngIf="highlightedFilename && isDocumentOrImage()"
            [innerHtml]="highlightedFilename"
            (click)="open()"
            class="name name--highlighted"
          ></div>
          <a
            *ngIf="!highlightedFilename && !isDocumentOrImage()"
            href="{{ attachment.fileUrl }}"
            class="name"
            download
          >
            {{ attachment.filename }}
          </a>
          <a
            *ngIf="highlightedFilename && !isDocumentOrImage()"
            href="{{ attachment.fileUrl }}"
            [innerHtml]="highlightedFilename"
            class="name name--highlighted"
            download
          >
          </a>
        </ng-container>
      </rt-truncate>

      <div *ngIf="footerIcon || moreTemplate" layout-horizontal>
        <div *ngIf="footerIcon" class="footer__icon-wrap">
          <rt-icon [name]="footerIcon"></rt-icon>
        </div>
        <div *ngIf="moreTemplate">
          <rt-button
            #moreDropdownOrigin="rtOverlayOrigin"
            rt-overlay-origin
            variant="plain only-icon small-x"
            (click)="moreDropdown.open = !moreDropdown.open"
          >
            <rt-icon name="more-horiz"></rt-icon>
          </rt-button>

          <ng-template
            #moreDropdown="rtConnectedOverlay"
            rt-connected-overlay
            [hasBackdrop]="true"
            [origin]="moreDropdownOrigin"
            (backdropClick)="moreDropdown.open = false"
          >
            <ng-template
              [ngTemplateOutlet]="moreTemplate"
              [ngTemplateOutletContext]="{ attachmentAssignment: attachmentAssignment }"
            >
            </ng-template>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="user" *ngIf="hasUploader() && type === 'card'">
      <rt-avatar
        [type]="'image'"
        [size]="'small'"
        [shape]="'oval'"
        [imageSrc]="uploaderPhotoUrl()!"
      ></rt-avatar>
      <div layout-vertical>
        <div layout>
          <div class="user-name" text-medium>{{ uploaderName() }}</div>
          <rt-badge
            *ngIf="attachment.guestId"
            color="optional"
            [text]="'app.common.guest' | translate"
            margin-left-small-x
          >
          </rt-badge>
        </div>
        <rt-date [time]="attachment.createdAt"> </rt-date>
      </div>
    </div>
  </div>
</ng-template>
